import { render, staticRenderFns } from "./UserManual.vue?vue&type=template&id=4964f3b6&scoped=true&"
import script from "./UserManual.vue?vue&type=script&lang=js&"
export * from "./UserManual.vue?vue&type=script&lang=js&"
import style0 from "./UserManual.vue?vue&type=style&index=0&id=4964f3b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4964f3b6",
  null
  
)

export default component.exports